<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
            v-model="paymentWallet.show"
            @hidden="paymentWallet.show = false"
            size="lg"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12 text-center">
                            <h3 class="mb-0">กรุณาเลือกช่องทางชำระเงิน</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-lg-12">
                        <iframe ref="iframePayment" style="width:100%" height="550px" :src="paymentWallet.urlPayment"></iframe>

                        <div v-if="isAllowBanner()">
                            <a 
                                href="https://www.tqm.co.th/car-insurance/online?utm_source=affiliate&utm_medium=mysave&utm_campaign=onlineshippop"
                                target="_blank"
                            >
                                <img 
                                    src="../../assets/images/banner/shippop_x_tqm.png" 
                                    alt="SHIPPOP x TQM" 
                                    style="object-fit: contain; width: 100%; height: 100%;"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </card>
        </b-modal>
    </div>
</template>
<script>
const MESSAGE_PAGE_RENDERED 	    = 'PAGE_RENDERED';
const MESSAGE_INIT_IFRAME 		    = 'INIT_IFRAME';
const MESSAGE_WINDOW_RESIZE 	    = 'WINDOW_RESIZE';
const MESSAGE_CLIENT_CLICK_BACK 	= 'CLIENT_CLICK_BACK';
const MESSAGE_PAYMENT_STATUS 		= 'PAYMENT_STATUS';
const STATE_CONFIRM 				= 'CONFIRM';
const STATE_PROCESS                 = 'PROCESS';

export default {
    name: "ModalPaymentWallet" ,
    props: {
        paymentWallet: Object,
    },
    data(){
        return{
            paymentGwReady: false,
            paymentGwUrl: process.env.VUE_APP_PAYMENT_URL || 'https://payment-gw.shippop.dev'
        }
    },
    updated() {
        let _this = this;
        window.addEventListener(
            'message',
            function (event) {
                if (event.origin === _this.paymentGwUrl) {
                    let data = event.data;
                    switch (data.type) {
                        case MESSAGE_PAGE_RENDERED:
                            _this.paymentGwReady = true;
                            _this.postMessage(MESSAGE_INIT_IFRAME);
                            break;
                        case MESSAGE_CLIENT_CLICK_BACK:
                            _this.paymentWallet.show = false
                            break;
                        case MESSAGE_WINDOW_RESIZE:
                            var payload = data.payload;
                            _this.$refs.iframePayment.height = payload.clientHeight;
                            break;
                        case MESSAGE_PAYMENT_STATUS:
                            var payload = data.payload;
                            if (payload.state === STATE_CONFIRM || payload.state === STATE_PROCESS) {
                                setTimeout(() => {
                                   _this.$emit('topupSuccess' , payload.state)
                                }, 1000);
                            }
                            break;
                    }
                }
            },
			false,
        )
    },
    methods:{
        postMessage(type, payload = {}) {
            this.$refs.iframePayment.contentWindow.postMessage(
                {
                    type: type,
                    payload: payload,
                },
                this.paymentGwUrl,
            );
        },
        isAllowBanner() {
            return this.$THEME.name === 'shippop'
        }
    }
}
</script>
